import { Injectable, inject } from '@angular/core';
import { VersichererCacheBaseService } from '@comparit/calculator';
import { Sparte, type Versicherer, VersichererService } from '@comparit/common-api';

/** The Hausrat insurers; the results page reads their logos by BaFin number. */
@Injectable({ providedIn: 'root' })
export class VersichererCacheService extends VersichererCacheBaseService<Versicherer> {
  private readonly versichererService = inject(VersichererService);

  protected readonly fetch$ = () => this.versichererService.getVersicherer({ sparte: Sparte.Hr });
}
